export default "__VITE_ASSET__CA5U8fZ7__"